import { __makeTemplateObject } from "tslib";
import { css } from '../styled-components';
import { palette2 } from './newPalette';
import { radius } from './radius';
export var focusVisible = '&.focus-visible, &[data-focus-visible-added]';
export var focusWithin = '&:hover, &:focus-within';
export var focusVisibleColor = palette2('interactive', 'f01');
export var shadowBorder = function (r, color, inset, size) {
    if (r === void 0) { r = 'zero'; }
    if (color === void 0) { color = focusVisibleColor; }
    if (inset === void 0) { inset = true; }
    if (size === void 0) { size = 1; }
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    box-shadow: ", " 0 0 0 ", "px ", ";\n    border-radius: ", ";\n    pointer-events: none;\n  }\n"], ["\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    box-shadow: ", " 0 0 0 ", "px ", ";\n    border-radius: ", ";\n    pointer-events: none;\n  }\n"])), inset ? 'inset' : '', size, color, radius(r));
};
export var focusVisibleShadowStyle = function (r, color, inset, size) {
    if (inset === void 0) { inset = true; }
    if (size === void 0) { size = 1; }
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", " {\n    ", ";\n  }\n"], ["\n  ", " {\n    ", ";\n  }\n"])), focusVisible, shadowBorder(r, color, inset, size));
};
var templateObject_1, templateObject_2;
